export const SET_VIDEO_FILE = "SET_VIDEO_FILE";
export const SET_VIDEO_NAME = "SET_VIDEO_NAME";
export const SET_USER_DATA = "SET_USER_DATA";

export default {
    SET_VIDEO_FILE,
    SET_VIDEO_NAME,
    SET_USER_DATA
};
